import { ArrowRight, CheckCircle } from 'lucide-react';

const HERO_IMAGE = "https://images.pexels.com/photos/4065617/pexels-photo-4065617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const HeroSection = () => {
  const highlights = [
    'Trusted Since 2012',
    'Authorized Dealer',
    'AMC Services',
  ];

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="hero-bg min-h-screen flex items-center pt-20"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="opacity-0 animate-fade-in-up">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-slate-800/50 rounded-full px-4 py-2 mb-8">
              <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
              <span className="text-sm font-medium tracking-widest uppercase text-slate-300">
                Bengaluru's Trusted IT Partner
              </span>
            </div>

            {/* Headline */}
            <h1
              data-testid="hero-headline"
              className="text-5xl md:text-7xl font-bold tracking-tight uppercase leading-[0.9] text-slate-50 mb-6"
            >
              Your Complete
              <span className="block text-orange-500">IT Solutions</span>
              Partner
            </h1>

            {/* Subheadline */}
            <p
              data-testid="hero-subheadline"
              className="text-lg md:text-xl leading-relaxed text-slate-400 max-w-lg mb-8"
            >
              Specialists in branded laptops, CCTV surveillance, biometrics, and comprehensive computer repair services.
            </p>

            {/* Highlights */}
            <div className="flex flex-wrap gap-4 mb-10">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 text-slate-300"
                >
                  <CheckCircle className="h-5 w-5 text-orange-500" />
                  <span className="font-medium">{item}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-primary"
                className="btn-lift inline-flex items-center justify-center gap-2 bg-orange-500 text-white font-bold tracking-wider uppercase px-8 py-4 rounded-none cursor-default"
              >
                Explore Products
                <ArrowRight className="h-5 w-5" />
              </button>
              <button
                data-testid="hero-cta-secondary"
                className="inline-flex items-center justify-center gap-2 border-2 border-slate-500 text-slate-300 font-bold tracking-wider uppercase px-8 py-4 rounded-none hover:bg-slate-800 hover:border-slate-400 transition-colors cursor-default"
              >
                Our Services
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative opacity-0 animate-fade-in-up animate-delay-200">
            <div className="relative overflow-hidden rounded-sm">
              {/* Orange accent corner */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-orange-500 z-10"></div>
              
              <img
                src={HERO_IMAGE}
                alt="Modern workspace with laptop"
                data-testid="hero-image"
                className="w-full h-[500px] object-cover"
              />
              
              {/* Stats overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 to-transparent p-8">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-3xl font-bold text-orange-500">13+</div>
                    <div className="text-sm text-slate-400 uppercase tracking-wider">Years</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-orange-500">5K+</div>
                    <div className="text-sm text-slate-400 uppercase tracking-wider">Clients</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-orange-500">100%</div>
                    <div className="text-sm text-slate-400 uppercase tracking-wider">Support</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 shadow-xl rounded-sm hidden lg:block">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <CheckCircle className="h-6 w-6 text-white" />
                </div>
                <div>
                  <div className="font-bold text-slate-900">Authorized Dealer</div>
                  <div className="text-sm text-slate-500">Lenovo, HP, CP Plus, Hikvision</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
